'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
require('react');
var core_Loading_DotsLoader_style = require('./DotsLoader.style.js');
var react = require('@emotion/react');
require('@babel/runtime/helpers/taggedTemplateLiteral');
require('styled-system');
require('@emotion/styled');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);

var _excluded = ["animationDuration", "size", "borderColor"];
var defaultAnimationDuration = 1.5;
var defaultSize = 30;
var Loading = function Loading(_ref) {
  var _ref$animationDuratio = _ref.animationDuration,
    animationDuration = _ref$animationDuratio === void 0 ? defaultAnimationDuration : _ref$animationDuratio,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultSize : _ref$size,
    _ref$borderColor = _ref.borderColor,
    borderColor = _ref$borderColor === void 0 ? 'borders-brand-primary' : _ref$borderColor,
    restOfProps = _objectWithoutProperties__default["default"](_ref, _excluded);
  return react.jsx(core_Loading_DotsLoader_style.SDotsLoader, _extends__default["default"]({
    borderColor: borderColor,
    animationDuration: animationDuration,
    size: size
  }, restOfProps), react.jsx("span", null));
};

exports["default"] = Loading;
//# sourceMappingURL=DotsLoader.js.map
